export const Tab = {
    MenuGenerator: 'menu-generator',
    Top10: 'top-10',
};
